import { useState, useRef, useEffect } from 'react'
import { SettingsIcon } from './icons'
import { PlaygroundDeviceSelector } from './PlaygroundDeviceSelector'

export function SettingsDropdown() {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="p-2 rounded-lg hover:bg-muted transition-colors text-muted-foreground hover:text-foreground"
      >
        <SettingsIcon className="w-6 h-6" />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-80 bg-card border border-border rounded-lg shadow-lg z-50">
          <div className="p-4 space-y-4">
            <h3 className="text-sm font-medium text-foreground">Settings</h3>

            <div className="space-y-4">
              <PlaygroundDeviceSelector
                kind="audioinput"
                onDeviceChange={deviceId => {
                  console.log('Audio input changed:', deviceId)
                }}
              />

              <PlaygroundDeviceSelector
                kind="videoinput"
                onDeviceChange={deviceId => {
                  console.log('Video input changed:', deviceId)
                }}
              />

              <PlaygroundDeviceSelector
                kind="audiooutput"
                onDeviceChange={deviceId => {
                  console.log('Audio output changed:', deviceId)
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
